import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const faTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'نام (حروف کوچک، بدون نویسه خاص)',
    add: 'اضافه کنید',
    allowedFileTypes: 'انواع فایل های مجاز',
    allowedFileTypesDescription:
      'محدود کردن انواع فایل های مجاز (به عنوان مثال، تصویر/*، برنامه/pdf). خالی بگذارید تا همه انواع مجاز باشند.',
    allowMultipleFiles: 'اجازه دادن به چندین فایل',
    amountInCents: 'مبلغ به سنت',
    basePrice: 'قیمت پایه',
    bcc: 'BCC',
    brand: 'نام تجاری',
    cc: 'CC',
    checkboxPlural: 'فیلدهای چک باکس',
    checkboxSingular: 'چک باکس',
    checkedByDefault: 'به طور پیش فرض بررسی شده است',
    chooseConfirmationType:
      'انتخاب کنید که آیا بعد از ارسال فرم، پیامی در صفحه نمایش داده شود یا به صفحه دیگری هدایت شود.',
    condition: 'وضعیت',
    confirmationMessage: 'پیام تایید',
    confirmationType: 'نوع تایید',
    countryPlural: 'رشته های کشور',
    countrySingular: 'کشور',
    creditCard: 'کارت اعتباری',
    customURL: 'URL سفارشی',
    datePlural: 'فیلدهای تاریخ',
    dateSingular: 'تاریخ',
    defaultValue: 'مقدار پیش فرض',
    divide: 'تقسیم کنید',
    documentToLinkTo: 'سندی برای پیوند دادن',
    doesNotEqual: 'برابر نیست',
    emailFrom: 'ایمیل از',
    emailPlural: 'فیلدهای ایمیل',
    emailsDescription:
      'هنگام ارسال فرم، ایمیل های سفارشی ارسال کنید. از فهرست‌های جدا شده با کاما برای ارسال یک ایمیل به چندین گیرنده استفاده کنید. برای ارجاع به یک مقدار از این فرم، نام آن فیلد را با دو براکت فرفری، یعنی {{firstName}} بپیچید. می‌توانید از علامت {{*}} برای خروجی همه داده‌ها و از {{*:table}} برای قالب‌بندی آن‌ها به عنوان جدول HTML در ایمیل استفاده کنید.',
    emailSingular: 'ایمیل',
    emailTo: 'ایمیل به',
    equals: 'برابر است',
    field: 'میدان',
    fields: 'فیلدها',
    fieldWidth: 'عرض فیلد (درصد)',
    hasAnyValue: 'هر ارزشی دارد',
    internalLink: 'لینک داخلی',
    label: 'برچسب بزنید',
    maxFileSize: 'حداکثر اندازه فایل (بایت)',
    maxFileSizeDescription: 'حداکثر اندازه فایل بر حسب بایت بدون محدودیت خالی بگذارید.',
    message: 'پیام',
    messageDescription: 'پیامی که باید در این ایمیل ارسال شود را وارد کنید.',
    messagePlural: 'بلوک های پیام',
    messageSingular: 'پیام',
    mimeType: 'نوع MIME',
    mimeTypePlural: 'انواع MIME',
    mimeTypeSingular: 'نوع MIME',
    multiply: 'ضرب کنید',
    numberPlural: 'فیلدهای شماره',
    numberSingular: 'شماره',
    optionPlural: 'گزینه ها',
    optionSingular: 'گزینه',
    paymentFieldPlural: 'زمینه های پرداخت',
    paymentFieldSingular: 'پرداخت',
    paymentProcessor: 'پردازشگر پرداخت',
    paymentStatus: 'وضعیت',
    placeholder: 'جای جای',
    priceConditions: 'شرایط قیمت',
    priceConditionsPlural: 'شرایط قیمت',
    priceConditionsSingular: 'وضعیت قیمت',
    radioOptions: 'گزینه های ویژگی رادیویی',
    radioPlural: 'زمینه های رادیویی',
    radioSingular: 'رادیو',
    redirect: 'تغییر مسیر',
    replyTo: 'پاسخ به',
    required: 'مورد نیاز',
    selectOptions: 'گزینه ها را انتخاب کنید',
    selectPlural: 'فیلدها را انتخاب کنید',
    selectSingular: 'انتخاب کنید',
    statePlural: 'زمینه های ایالتی',
    stateSingular: 'ایالت',
    staticValue: 'مقدار استاتیک',
    subject: 'موضوع',
    submitButton: 'برچسب دکمه ارسال',
    subtract: 'تفریق',
    textareaPlural: 'فیلدهای Textarea',
    textareaSingular: 'Textarea',
    textPlural: 'فیلدهای متنی',
    textSingular: 'متن',
    title: 'عنوان',
    token: 'نشانه',
    uploadCollection: 'آپلود مجموعه',
    uploadCollectionDescription: 'انتخاب کنید که کدام مجموعه آپلود فایل ها را در آن ذخیره کنید',
    uploadFieldPlural: 'فیلدهای آپلود',
    uploadFieldSingular: 'آپلود کنید',
    urlToRedirectTo: 'URL برای تغییر مسیر به',
    value: 'ارزش',
    valueOfField: 'ارزش میدان',
    valueType: 'نوع ارزش',
  },
}

export const fa: PluginLanguage = {
  dateFNSKey: 'fa-IR',
  translations: faTranslations,
}
